import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import FontKeys from '../FontKeys';
import gameData from '../gameData';
import CreatorStepInput from './CreatorStepInput';

export default class CreatorStep extends Phaser.GameObjects.Container
{
    /**
     * 
     * @param {Phaser.Scene} scene 
     */
    constructor(scene, stepInfo)
    {
        super(scene);

        let inputsY = 0;
        if (stepInfo['inst'] != "")
        {
            //add inst text
            this.inst = ABCyaPhaser.Text.addText(50, 0, 42, 0x3258a7, FontKeys._asapregular, stepInfo['inst'], this, false).setOrigin(0).setWordWrapWidth(550);
            //set btn position lower if there are instructions show
            inputsY = this.inst.height + 20;
        }
        //input boxes
        this.inputYPositions = [];
        this.inputs = [];
        let dataObjs = stepInfo['inputs'];
        let len = dataObjs.length;
        
        for (let i = 0; i < len; i++)
        {
            let stepInput = new CreatorStepInput(this.scene, dataObjs[i]);
            this.inputYPositions.push(inputsY + (150 * i));
            this.inputs.push(stepInput);
            this.add(stepInput);
            stepInput.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => this.selectInput(stepInput));
            stepInput.alpha = 0;
        }
    }

    setUpStep()
    {
        let len = this.inputs.length;
        for (let i = 0; i < len; i++)
        {
            let inp = this.inputs[i];
            this.scene.time.delayedCall(i * 2, inp.slideIn, [0, this.inputYPositions[i]], inp);
        }

        //place focus on first step
        this.activeInput = this.inputs[0];
        this.activeInput.setActive(true);
    }

    checkInputComplete()
    {
        let stepComplete = true;
        if (gameData.letterData[this.inputs[0].inputId] == "") stepComplete = false;
        return stepComplete;
    }

    removeStep(outPt)
    {
        if (this.inst != null)
        {
            this.inst.setVisible(false);
        }
        let len = this.inputs.length;
        for (let i = 0; i < len; i++)
        {
            let inp = this.inputs[i];
            this.scene.time.delayedCall(i * 200, inp.slideOut, [outPt], inp);
        }

        this.scene.time.delayedCall(1200 * this.inputs.length, this.cleanUp, null, this);
    }

    selectInput(sender)
    {
        if (this.activeInput && this.activeInput != sender)
        {
            this.activeInput.setActive(false);
        }
        this.activeInput = sender;
        this.activeInput.setActive(true);
    }

    cleanUp()
    {
        this.destroy();
    }

    inputToStep(str)
    {
        this.activeInput.handleInput(str);
    }

    highlightStepRequired(snd)
    {
        this.inputs[0].highLightInput(snd);
    }
}